import { genId } from 'commons/utils';
import { useDialogsStore } from '../../stores/dialogs';

// Second argument to `modalInstance.dismiss`, so a dialog can tell a partner closing it from a
// navigation tearing it down — `dismissAllDialogs` passes none. Does not affect the rejection.
export const DIALOG_GESTURE = {
  CLOSE_BUTTON: 'close',
  BACKDROP: 'backdrop',
  ESC: 'esc',
};

// its okay if dialogs have no rejection handling
window.addEventListener('unhandledrejection', function (promiseRejectionEvent) {
  if (promiseRejectionEvent?.reason === 'dialogDismiss') {
    promiseRejectionEvent.preventDefault();
  }
});

document.addEventListener('keydown', function (evt) {
  const dialogsStore = useDialogsStore();

  if (evt.key === 'Escape' && dialogsStore.dialogCount > 0) {
    const latestDialog =
      dialogsStore.currentDialogs[dialogsStore.currentDialogs.length - 1];
    if (!latestDialog?.options?.preventEsc) {
      latestDialog.modalInstance.dismiss(undefined, DIALOG_GESTURE.ESC);
    }
  }
});

export default {
  async openDialog(component, data, options = {}) {
    const dialogsStore = useDialogsStore();
    const dialogId = genId('dialog');

    return new Promise((resolve, reject) => {
      dialogsStore.addDialog({
        id: dialogId,
        component,
        data,
        options,
        modalInstance: {
          close: (args) => {
            dialogsStore.removeDialog(dialogId);
            resolve(args);
          },
          dismiss: (args) => {
            dialogsStore.removeDialog(dialogId);

            if (args && !(args instanceof Event)) {
              reject(args);
            } else {
              reject('dialogDismiss');
            }
          },
        },
      });
    });
  },
  dismissAllDialogs() {
    const dialogsStore = useDialogsStore();

    dialogsStore.currentDialogs.forEach((dialog) =>
      dialog.modalInstance.dismiss(),
    );
  },
};
